import { parseFormattedSegments } from "@/src/utils/rich-text.utils";
import { Linking, Text, TextProps } from "react-native";

export const FormattedSegments = ({ text }: Readonly<{ text?: string | null }>) => (
  <>
    {parseFormattedSegments(text ?? "").map((segment, index) => {
      const key = `seg-${index}`;
      const style = {
        fontWeight: segment.bold ? ("700" as const) : undefined,
        fontStyle: segment.italic ? ("italic" as const) : undefined,
      };

      if (segment.url) {
        return (
          <Text
            key={key}
            style={style}
            className="text-primary underline"
            onPress={() => {
              Linking.openURL(segment.url as string).catch(() => {
                // A blocked pop-up or unsupported scheme is not worth a crash.
              });
            }}
            accessibilityRole="link"
          >
            {segment.text}
          </Text>
        );
      }

      if (segment.bold || segment.italic) {
        return (
          <Text key={key} style={style}>
            {segment.text}
          </Text>
        );
      }

      return segment.text;
    })}
  </>
);

type FormattedTextProps = Readonly<
  Omit<TextProps, "children"> & {
    /** Body copy that may carry bold/italic/link markers. */
    children?: string | null;
  }
>;

const FormattedText = ({ children, ...textProps }: FormattedTextProps) => (
  <Text {...textProps}>
    <FormattedSegments text={children} />
  </Text>
);

export default FormattedText;
